module.exports = __webpack_public_path__ + "img/shield-xmark.bc061256.svg";